export interface UnlockedBadge {
  id: string;
  unlocked_at: string;
}

export interface ProviderGamification {
  badges: UnlockedBadge[];
  shown_badges: string[];
}

export const DEFAULT_GAMIFICATION: ProviderGamification = {
  badges: [],
  shown_badges: [],
};

export type BadgeRarity = 'common' | 'rare' | 'epic';
export type CelebrationType = 'badge' | 'celebration';

export interface BadgeDefinition {
  id: string;
  name: string;
  description: string;
  rarity: BadgeRarity;
  celebrationType: CelebrationType;
  icon: string;
}

export interface BadgeNotificationData {
  badge: BadgeDefinition;
  unlockedAt: string;
}
